import { render, staticRenderFns } from "./HistoryMoney.vue?vue&type=template&id=227bb16f&scoped=true&"
import script from "./HistoryMoney.vue?vue&type=script&lang=js&"
export * from "./HistoryMoney.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMoney.vue?vue&type=style&index=0&id=227bb16f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bb16f",
  null
  
)

component.options.__file = "HistoryMoney.vue"
export default component.exports